<template>

    <div class="route-projects">
        <div class="padding-box">
            <cms-heading class="page-heading" level="1" title="Projecten" icon="magicon-folder-opened">
                <cms-button color="positive" icon="magicon-plus" route="project-add">Project toevoegen</cms-button>
            </cms-heading>

            <cms-heading level="2" title="Alle projecten">
                <cms-searchbar v-model="searchQuery"></cms-searchbar>
            </cms-heading>

            <cms-pagination class="top-pagination" :pages="pageCount" v-model="page"></cms-pagination>

            <cms-table clickable="true" v-spinner="loading" :item-count="totalItems" :items-per-page="itemsPerPage" :page="page" :offset="offset" @page="switchPage" :placeholder="projects && !projects.items.length">
                <cms-table-header>
                    <cms-th field="title" v-model="sort">Project</cms-th>
                    <cms-th field="code" v-model="sort">Project code</cms-th>
                    <cms-th field="createdAt" v-model="sort">Aangemaakt op</cms-th>
                    <cms-th></cms-th>
                </cms-table-header>
                <tr v-for="project in (projects || {}).items" @click="navigateProjectEdit(project.id)">
                    <td>{{ project.title }}</td>
                    <td>{{ project.code }}</td>
                    <td>{{ project.createdAt | date('LLL') }}</td>
                    <td class="actions" @click.stop>
                        <cms-link icon="img icon-table-pencil-dark" v-tooltip="'Wijzigen'" @click="navigateProjectEdit(project.id)" />
                        <cms-link icon="img icon-table-cross-dark" v-tooltip="'Verwijderen'" @click="onDeleteProject(project.id)" />
                    </td>
                </tr>
            </cms-table>
        </div>
    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import createQuery from '@wittignl/js-core/apollo/queries/createQuery'
    import AllProjectsQuery from 'gql/queries/Projects/AllProjects.gql'
    import ProjectMutations from "app/mutations/ProjectMutations";

    @Component({

        name: 'projects',
        apollo: {

            projects: createQuery(AllProjectsQuery, {

                fetchPolicy: 'cache-and-network',

                variables(){

                    return {
                        offset: this.offset,
                        limit: this.itemsPerPage,
                        search: this.searchQuery,
                        sortField: this.sort.field,
                        sortDirection: this.sort.direction
                    }
                }
            })
        }
    })
    export default class Projects extends Vue
    {
        static SORT_STORAGE_KEY = "ProjectsSort";
        static SEARCH_STORAGE_KEY = "ProjectsSearch";

        data() {

            return {
                projects: null,
                loading: 0,

                offset: 0,
                itemsPerPage: 30,
                searchQuery: this.$storage.getSession(Projects.SEARCH_STORAGE_KEY, null),
                sort: this.$storage.getSession(Projects.SORT_STORAGE_KEY, {
                    field: 'title',
                    direction: 'ASC'
                })
            };
        }

        created() {

            this.logger = this.$di.logger.child('Projects');
        }

        mounted() {

        }

        breadcrumb(){

            return 'Projecten';
        }

        async onDeleteProject(id) {

            const { result } = await this.$di.alert.confirm('Weet je zeker dat je dit project wilt verwijderen?');
            if(result) {

                await this.deleteProject(id);

                this.$refetchQuery('projects');
            }
        }

        async deleteProject(id) {

            try {

                await ProjectMutations.delete(id);

                this.logger.info(`Project ${id} has successfully been deleted`);
                this.$toast.success('Het project is succesvol verwijderd');
            }
            catch(e) {

                this.logger.error('Error deleting report', e);
                this.$toast.error('Het project kon niet worden verwijderd');
            }
        }

        switchPage(offset){

            this.offset = offset;
        }

        get totalItems(){

            return this.projects ? this.projects.totalCount : 0;
        }

        get pageCount(){

            if(!this.projects){
                return 0;
            }

            return Math.ceil(parseInt(this.projects.totalCount) / this.itemsPerPage);
        }

        get page(){

            return Math.floor(this.offset / parseInt(this.itemsPerPage)) + 1;
        }

        set page(page){

            this.offset = parseInt(this.itemsPerPage) * (page - 1);
        }

        navigateProjectEdit(projectId) {

            this.$router.push({ name: 'project-edit', params: { id: projectId } });
        }
    }

</script>
